"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isRaffleTicket(object) {
    return checkRaffleTicket(object).fulfilled;
}
exports.isRaffleTicket = isRaffleTicket;
function checkRaffleTicket(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("ticketId"), Check_1.hasString("raffleId"), Check_1.hasString("userId"), Check_1.hasString("date")).withOptions(options).explain();
}
exports.checkRaffleTicket = checkRaffleTicket;
//# sourceMappingURL=RaffleTicket.js.map